import { z } from 'zod';

import { getJobFormFileSchema } from './sharedSchemas';
import { categoryKeyRequiredMsg } from './validationErrors';

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

const webStyleIDsFileSchema = getJobFormFileSchema(MAX_FILE_SIZE);

export const categoryEditorSchema = z.object({
    webStyleIDsFile: webStyleIDsFileSchema,
    categoryKey: z
        .string({
            error: issue => (issue.input === undefined ? categoryKeyRequiredMsg : undefined),
        })
        .trim()
        .min(1, categoryKeyRequiredMsg),
});
